// 모바일
import { useEffect, useState } from "react";

export function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.innerWidth < breakpoint;
  });

  useEffect(() => {
    if (typeof window === "undefined") return;

    const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);

    const handler = (e) => setIsMobile(e.matches);

    // 초기값
    setIsMobile(mql.matches);
    // 변화 감지
    mql.addEventListener("change", handler);

    return () => mql.removeEventListener("change", handler);
  }, [breakpoint]);

  return isMobile;
}
